import { createBrowserRouter } from 'react-router-dom';

import { routes } from './routes';

export const router = createBrowserRouter(routes);

// Ключ хранилища ScrollRestoration (react-router: SCROLL_RESTORATION_STORAGE_KEY)
const SCROLL_STORAGE_KEY = 'react-router-scroll-positions';

/**
 * Перед гидратацией: страница остаётся там, где стоит. ScrollRestoration узнаёт сохранённую
 * позицию только вторым рендером, а первым делает scrollTo(0, 0) — после обновления страницы,
 * прокрученной вниз, её отбрасывало к началу и через ~150 мс возвращало (видео владельца
 * 29.10.2026). Текущая позиция — та, что восстановил браузер или успел прокрутить посетитель,
 * пока грузился JS. ScrollRestoration потом берёт эти же позиции из sessionStorage
 */
export const keepScrollOnHydrate = (): void => {
  let positions: Record<string, number> = {};
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY) ?? '{}');
    if (typeof stored === 'object' && stored !== null) positions = stored as Record<string, number>; // as: JSON.parse не знает формы
  } catch {
    // Без хранилища — только текущая позиция
  }
  positions[router.state.location.key] = window.scrollY;
  router.enableScrollRestoration(positions, () => window.scrollY);
};

/**
 * Начальный маршрут готов: route.lazy совпавшей страницы загружен. Гидратировать раньше нельзя —
 * роутер отрисовал бы пустую страницу вместо пререндера, и React выбросил бы серверный HTML
 */
export const routerReady = (): Promise<void> =>
  router.state.initialized
    ? Promise.resolve()
    : new Promise((resolve) => {
        const unsubscribe = router.subscribe((state) => {
          if (!state.initialized) return;
          unsubscribe();
          resolve();
        });
      });
